export default __webpack_public_path__ + "media/images/paylogos/color/mastercard@2x-a6b8222309cf9442e1b6301a9b2177f7.png";